// Geometría del lienzo (compartida por MapCanvas y canvasModel): dos columnas fijas, preguntas a la
// izquierda y la entidad a la derecha, con filas de alto constante.
export const ALIAS_X = 24;
export const ALIAS_W = 300;
export const GUTTER = 200;
export const ENTITY_X = ALIAS_X + ALIAS_W + GUTTER;
export const ENTITY_W = 420;
export const TOP_Y = 24;
export const HEADER_H = 46;
export const ROW_H = 24;
export const COV_DOTS_MAX = 8;

/** Curva de a (salida) a b (llegada): puntos de control horizontales. */
export function bezierPts(a, b) {
  const dx = Math.max(60, Math.abs(b.x - a.x) / 2);
  return [a, { x: a.x + dx, y: a.y }, { x: b.x - dx, y: b.y }, b];
}

export function bezier(a, b) {
  const [, c1, c2] = bezierPts(a, b);
  return `M ${a.x} ${a.y} C ${c1.x} ${c1.y}, ${c2.x} ${c2.y}, ${b.x} ${b.y}`;
}

/** Punto de la curva en t ∈ [0, 1]. */
export function bezierPoint(a, b, t) {
  const [p0, p1, p2, p3] = bezierPts(a, b);
  const u = 1 - t;
  const k = [u * u * u, 3 * u * u * t, 3 * u * t * t, t * t * t];
  return { x: k[0] * p0.x + k[1] * p1.x + k[2] * p2.x + k[3] * p3.x, y: k[0] * p0.y + k[1] * p1.y + k[2] * p2.y + k[3] * p3.y };
}
